// import {
//     CONFIRMED_GET_ASSIGNED_PATIENTS,
//     FAILED_GET_ASSIGNED_PATIENTS,
//     CONFIRMED_GET_TODAY_FOLLOWUPS,
//     FAILED_GET_TODAY_FOLLOWUPS,
//     CONFIRMED_GET_UPCOMING_FOLLOWUPS,
//     FAILED_GET_UPCOMING_FOLLOWUPS,
//   } from "../actions/ServiceCallerType";

//   const initialState = {
//     assignedPatients: [],
//     todayFollowUps: [],
//     upcomingFollowUps: [],
//     error: null,
//   };

//   export default function ServiceCallerReducer(state = initialState, action) {
//     switch (action.type) {
//       case CONFIRMED_GET_ASSIGNED_PATIENTS:
//         return {
//           ...state,
//           assignedPatients: action.payload,
//           error: null,
//         };

//       case FAILED_GET_ASSIGNED_PATIENTS:
//         return {
//           ...state,
//           error: action.payload,
//         };

//       case CONFIRMED_GET_TODAY_FOLLOWUPS:
//         return {
//           ...state,
//           todayFollowUps: action.payload,
//           error: null,
//         };

//       case FAILED_GET_TODAY_FOLLOWUPS:
//         return {
//           ...state,
//           error: action.payload,
//         };

//       case CONFIRMED_GET_UPCOMING_FOLLOWUPS:
//         return {
//           ...state,
//           upcomingFollowUps: action.payload,
//           error: null,
//         };

//       case FAILED_GET_UPCOMING_FOLLOWUPS:
//         return {
//           ...state,
//           error: action.payload,
//         };

//       default:
//         return state;
//     }
//   }
import {
  CONFIRMED_GET_ASSIGNED_PATIENTS,
  FAILED_GET_ASSIGNED_PATIENTS,
  CONFIRMED_GET_TODAY_FOLLOWUPS,
  FAILED_GET_TODAY_FOLLOWUPS,
  CONFIRMED_GET_UPCOMING_FOLLOWUPS,
  FAILED_GET_UPCOMING_FOLLOWUPS,
  CONFIRMED_GET_EMERGENCY_PATIENTS,
  FAILED_GET_EMERGENCY_PATIENTS,
  CONFIRMED_GET_DROPPED_PATIENTS,
  FAILED_GET_DROPPED_PATIENTS,
  CONFIRMED_MARK_EMERGENCY,
  FAILED_MARK_EMERGENCY,

  CONFIRMED_GET_71221_FOLLOWUPS,
  FAILED_GET_71221_FOLLOWUPS,
  CONFIRMED_GET_ROUTED_PATIENTS,
FAILED_GET_ROUTED_PATIENTS,
} from "../actions/ServiceCallerType";

const initialState = {
  assignedPatients: [],
  todayFollowUps: [],
  upcomingFollowUps: [],
  routedPatients: [],
  emergencyPatients: [],
  droppedPatients: [],
  followup71221Days: [],

  markEmergencySuccess: false,

  error: null,
};

export default function ServiceCallerReducer(state = initialState, action) {
  switch (action.type) {

    // ✅ ASSIGNED PATIENTS
    case CONFIRMED_GET_ASSIGNED_PATIENTS:
      return {
        ...state,
        assignedPatients: action.payload,
        error: null,
      };

    case FAILED_GET_ASSIGNED_PATIENTS:
      return {
        ...state,
        error: action.payload,
      };


    // ✅ TODAY FOLLOWUPS
    case CONFIRMED_GET_TODAY_FOLLOWUPS:
      return {
        ...state,
        todayFollowUps: action.payload,
        error: null,
      };

    case FAILED_GET_TODAY_FOLLOWUPS:
      return {
        ...state,
        error: action.payload,
      };


    // ✅ UPCOMING FOLLOWUPS
    case CONFIRMED_GET_UPCOMING_FOLLOWUPS:
      return {
        ...state,
        upcomingFollowUps: action.payload,
        error: null,
      };

    case FAILED_GET_UPCOMING_FOLLOWUPS:
      return {
        ...state,
        error: action.payload,
      };


    // 🚨 EMERGENCY PATIENTS LIST
    case CONFIRMED_GET_EMERGENCY_PATIENTS:
      return {
        ...state,
        emergencyPatients: action.payload,
        error: null,
      };

    case FAILED_GET_EMERGENCY_PATIENTS:
      return {
        ...state,
        error: action.payload,
      };


    // ⚠️ DROPPED PATIENTS LIST
    case CONFIRMED_GET_DROPPED_PATIENTS:
      return {
        ...state,
        droppedPatients: action.payload,
        error: null,
      };

    case FAILED_GET_DROPPED_PATIENTS:
      return {
        ...state,
        error: action.payload,
      };


    // 🚨 MARK EMERGENCY
    case CONFIRMED_MARK_EMERGENCY:
      return {
        ...state,
        markEmergencySuccess: true,
        error: null,
      };

    case FAILED_MARK_EMERGENCY:
      return {
        ...state,
        markEmergencySuccess: false,
        error: action.payload,
      };

    case CONFIRMED_GET_71221_FOLLOWUPS:
      return {
        ...state,
        followup71221Days: action.payload,
      };

    case FAILED_GET_71221_FOLLOWUPS:
      return {
        ...state,
        error: action.payload,
      };

      // 🚗 ROUTED PATIENTS
case CONFIRMED_GET_ROUTED_PATIENTS:
  return {
    ...state,
    routedPatients: action.payload,
    error: null,
  };

case FAILED_GET_ROUTED_PATIENTS:
  return {
    ...state,
    error: action.payload,
  };
    default:
      return state;
  }
}